export default __webpack_public_path__ + "static/media/about-img-1.5feadd32.png";